import {DialogController} from 'aurelia-dialog';
import {autoinject, LogManager} from 'aurelia-framework';
import { ItemStatus, ThemeColor } from "data/entities/entities";
import { ThemeColorService } from "data/service/theme-color-service";
import { ItemStatusService } from "data/service/item-status-service";

@autoinject()
export class EditStatusTypes {
	logger = LogManager.getLogger('EditStatusTypes');
    items: Array<ItemStatus>;
    colors: Array<ThemeColor>;
    constructor(
        private controller: DialogController,
        private themeColorService: ThemeColorService,
        private itemStatusService: ItemStatusService
    ) {
        this.controller = controller;
        this.controller.settings.lock = true;

    }

	async attached() {
		try {
			this.items = await this.itemStatusService.list();
			this.colors = await this.themeColorService.list(1, 1);
		}
		catch (error) {
			this.logger.error(error);
		}
	}

    //selectedColorChanged(item:ItemStatus, color:ThemeColor) {
    //    item.themeColor = color;
        
    //}

    activate() {
        
    }

    saveData() {
        this.items.forEach((a:ItemStatus) => {
            a.save();
        });


        this.controller.ok(this.items);
    }
}
